var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',{staticClass:"py-10 text-center",attrs:{"cols":"12"}},[_c('BaseText',{staticClass:"font-weight-bold"},[_vm._v(" 表示可能な教材が存在しません。 ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }